<template>
  <!-- ************************************************** --
    -- ソートダイアログ
    -- ************************************************** -->
  <!-- 乗務員チップ -->
  <!-- <modal name="driver-sort-dialog" class="modalZIndex" :draggable="true" :resizable="false" width="450" :maxWidth="450" height="270" :maxHeight="270" :reset="true" :clickToClose="false"> -->
  <v-dialog v-model="showDialog" height="80%" width="450" max-width="90%" style="z-index:500" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="1" color="#6091d3" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>乗務員情報並び替え</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onClickDriverSortClose" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row no-gutters align-content="center" class="my-1">
            <div class="px-1 ml-7" style="font-weight:bold;color:navy">入力後[OK]押下で反映されます。</div>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols=1 />
            <v-col :cols=5>
              <dd-drop-down
                label="第１キー"
                placeholder="選択してください"
                v-model="driverSortArgs.driverSortKeyValue1"
                :items="driverSortList"/>
            </v-col>
            <v-col :cols=1 />
            <v-col :cols=5>
              <v-radio-group v-model="driverSortArgs.driverSortKey1" row>
                <dd-radio-button label="昇順" value="asc" />
                <dd-radio-button label="降順" value="desc" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols=1 />
            <v-col :cols=5>
              <dd-drop-down
                label="第２キー"
                placeholder="選択してください"
                v-model="driverSortArgs.driverSortKeyValue2"
                :items="driverSortList"/>
            </v-col>
            <v-col :cols=1 />
            <v-col :cols=5>
              <v-radio-group v-model="driverSortArgs.driverSortKey2" row>
                <dd-radio-button label="昇順" value="asc" />
                <dd-radio-button label="降順" value="desc" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center" class="my-1">
            <v-col :cols=1 />
            <v-col :cols=5>
              <dd-drop-down
                label="第３キー"
                placeholder="選択してください"
                v-model="driverSortArgs.driverSortKeyValue3"
                :items="driverSortList"/>
            </v-col>
            <v-col :cols=1 />
            <v-col :cols=5>
              <v-radio-group v-model="driverSortArgs.driverSortKey3" row>
                <dd-radio-button label="昇順" value="asc" />
                <dd-radio-button label="降順" value="desc" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickDriverSortClose">閉じる</v-btn>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickDriverSortClear">クリア</v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickDriverSortExec">ＯＫ</v-btn>
      </v-card-actions>
    </v-card>
  <!-- </modal> -->
  </v-dialog>
</template>

<script>
// ----- <ここからJavaScript> ------------------------------------------------------------------------------------------------------------------------
//
//
// ************************************************************************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************************************************************************
//
//
//
// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
// import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'

// vue Definition
// import { mapGetters } from 'vuex'
// DdComponents アルファベット順記述
const DdDropDown = () => import('@/components/DdDropDown')
const DdRadioButton = () => import('@/components/DdRadioButton')

export default {
  name: 'DdHaishaDriverSortDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    // DdCheckbox,
    // DdCodeTextBox,
    // DdDataTable,
    // DdDateBox,
    // DdDefaultButton,
    DdDropDown,
    // DdFooterButton,
    // DdIconButtonWithTooltip,
    // DdNumericBox,
    DdRadioButton
    // DdSimpleTable,
    // DdSubHeader,
    // DdSubTitle,
    // DdSwitch,
    // DdTextArea,
    // DdTextBox,
    // DdTimeBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    param: {
      driverSortKey1: 'asc',
      driverSortKey2: 'asc',
      driverSortKey3: 'asc',
      driverSortKeyValue1: '',
      driverSortKeyValue2: '',
      driverSortKeyValue3: ''
    }
  },

  data: () => ({
    invalidMessage: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,

    // 乗務員ソート初期値
    driverSortArgs: {
      driverSortKey1: 'asc',
      driverSortKey2: 'asc',
      driverSortKey3: 'asc',
      driverSortKeyValue1: '',
      driverSortKeyValue2: '',
      driverSortKeyValue3: ''
    },
    driverSortList: [
      { value: 'jininCd', text: '人員コード' },
      { value: 'jininNm', text: '氏名' },
      { value: 'eigyoshoCd', text: '所属営業所コード' },
      { value: 'eigyoshoNm', text: '所属営業所名称' }
    ],

    // 戻り値用定義
    rec: {
      id: 0
    }
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        // ここに表示時やりたいこと書く
        this.driverSortArgs = Object.assign({}, this.param)
      }
    }
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize: function () {
      // const self = this
      // const opt = {
      //   loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu']
      // }
      // this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rec.chipColor = '#00FF00'
      this.chipColorTmp = this.rec.chipColor
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onClickDriverSortClose: function (e) {
      this.$emit('close', undefined)
    },
    onClickDriverSortExec: function (e) {
      console.log(this.param)
      console.log(this.driverSortArgs)
      this.$emit('exec', this.driverSortArgs)
    },
    // --------------------------------------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------------------------------------
    onClickDriverSortClear: function () {
      Object.assign(this.driverSortArgs, this.$options.data().driverSortArgs)
      this.$emit('exec', this.driverSortArgs)
    }
  }
}
</script>
<style></style>
